import { render } from "./QuizPart.vue?vue&type=template&id=6127e79e"
import script from "./QuizPart.vue?vue&type=script&lang=js"
export * from "./QuizPart.vue?vue&type=script&lang=js"

import "./QuizPart.vue?vue&type=style&index=0&id=6127e79e&lang=css"

import exportComponent from "C:\\Users\\aarhondakis\\Desktop\\lernapp_quellcode\\lernapp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__